exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qmodii .theme--light.v-sheet{background-color:#fff;border-color:#fff;color:rgba(0,0,0,.87)}.qmodii .theme--dark.v-sheet{background-color:#424242;border-color:#424242;color:#fff}.qmodii .v-sheet{display:block;border-radius:2px;position:relative;transition:.3s cubic-bezier(.25,.8,.5,1)}.qmodii .v-sheet--tile{border-radius:0}", ""]);

// exports
